// extracted by mini-css-extract-plugin
module.exports = {"publikumsmottak":"Reception_publikumsmottak__GHwYK","header":"Reception_header__ez9KS"};